export default __webpack_public_path__ + "static/media/icon-menu-manager-index.8663c88f.svg";